import { PushPin } from '@mui/icons-material';
import { Button } from '@mui/material';

type PinColumnsButtonProps = {
    altLabel?: string;
    onClick?: () => void;
};

export default function PinColumnsButton({ altLabel, onClick }: PinColumnsButtonProps) {
    return (
        <>
            <Button startIcon={<PushPin />} onClick={onClick}>
                {altLabel || 'Pin Columns'}
            </Button>
        </>
    );
}
